import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/facebook-constant";


export {
    addCampaigns,
    addSingleCampaign,
    saveSingleCampaign,
    updateSingleCampaign,
    getSingleCampaign,
    getAllCampaigns,
    searchCampaigns,
    searchCampaignsWithSearchCriteria,
    prepareCampaignsList
}

const collectionName = 'facebook-campaigns';
const collectionReference = collection(fireStoreDB, collectionName);

const addCampaigns = (campaigns) => {
    return Promise.map(campaigns, async campaign => {
        await addSingleCampaign(campaign);
    });
}

const addSingleCampaign = (campaign) => {
    campaign.createdAt = new Date();
    campaign.updatedAt = campaign.createdAt;
    return addDoc(collectionReference, campaign);
}

const updateSingleCampaign = (campaign) => {
    const documentReference = doc(fireStoreDB, collectionName, campaign.id);
    campaign.updatedAt = new Date();
    return setDoc(documentReference, campaign, {merge: true});
}

const saveSingleCampaign = (campaign) => {
    const documentReference = doc(fireStoreDB, collectionName, campaign.id);

    campaign.updatedAt = new Date();
    if (!campaign.createdAt) {
        campaign.createdAt = campaign.updatedAt;
    }

    return setDoc(documentReference, campaign, {merge: true});
}

const getSingleCampaign = async (campaignId) => {
    const documentReference = doc(fireStoreDB, collectionName, campaignId);
    const campaignDoc = await getDoc(documentReference);
    return prepareSingleCampaign(campaignDoc);
}

const getAllCampaigns = async () => {
    let searchQuery = query(collectionReference);
    const campaignsResult = await getDocs(searchQuery);
    return prepareCampaignsList(campaignsResult);
}

const searchCampaigns = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const campaignResult = await getDocs(searchQuery);
    return prepareCampaignsList(campaignResult);
}

const searchCampaignsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchCampaignsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const campaignResult = await getDocs(searchQuery);
    return prepareCampaignsList(campaignResult);
}

const prepareCampaignsList = (campaignResult) => {
    const campaignsList = [];

    _.forEach(campaignResult.docs, campaignDoc => {
        campaignsList.push(prepareSingleCampaign(campaignDoc));
    });

    return campaignsList;
}


const prepareSingleCampaign = (campaignDoc) => {
    const campaign = campaignDoc.data();
    campaign.id = campaignDoc.id;
    return campaign;
}
